import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import { Box } from '@material-ui/core'
import Breadcrumb from '../../Components/Breadcrumbs'
import ProgramHeader from '../../Components/ProgramHeader'
import ProgramView from '../../Components/ProgramView'
import { useStyles } from './style'
import { Cards, Graph } from '../../elements'
import { singleGraphData, clusterGraphData } from './graphData'
import { vppService } from '../../Services'
import { getProgramById } from '../../AppRedux/actions/Programs'
import Error404 from '../ErrorPages/Error404'

function ProgramScreen(props) {
  const classes = useStyles()
  const [vppCount, setVppCount] = useState(0)

  const programName = _.get(props.programDetails, 'program_name_admin_ui', '')
  const programIsActive = _.get(props.programDetails, 'is_active', false)

  useEffect(() => {
    const id = _.get(props.match.params, 'programs_id', '')
    if (props.accountId && id && id !== props.programId) {
      props.getProgramById({
        accountId: props.accountId,
        programId: id
      })
    }
  }, [props, props.match.params, props.programId, props.accountId])

  useEffect(() => {
    if (props.accountId && props.programId) {
      vppService.getAllProgramVpp(props.accountId, props.programId)
        .then((response) => {
          setVppCount(_.isEmpty(response) ? 0 : response.length)
        })
        .catch(() => {

        })
    }
  }, [props.programId, props.accountId])

  return (
    <Box>
      {props.notFound ? <Error404 /> :
        <>
          <Breadcrumb value={[{ 'Home': '/' }, { 'Programs': '/programs' }, { [programName]: '' }]} />
          <Box>
            <ProgramHeader
              programName={programName}
              isActive={programIsActive}
              programId={props.programId}
              programObject={props.programDetails}
              vppCount={vppCount}
              {...props}
            ></ProgramHeader>
            <ProgramView
              {...props}
              className={classes.programView}
              programName={programName}
              programId={props.programId}
              programDetail={props.programDetails}
              vppCount={vppCount}
              isActive={programIsActive}
            >
            </ProgramView>
          </Box>
        </>
      }
    </Box>
  )
}

const mapDispatchToProps = (dispatch) => ({
  getProgramById: (payload) => dispatch(getProgramById(payload)),
})

const mapStateToProps = ({ auth, programs }) => {
  const { accountId } = auth
  const { programId, programDetails, notFound } = programs
  return { accountId, programId, programDetails, notFound }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProgramScreen)
